/**
 * Filter inputs
 */

$(function () {

    if ($('.js-valid-numbers').length) {
        $('.js-valid-numbers').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9]*$/.test(value);
            });
        });
    }
    if ($('.js-valid-letters').length) {
        $('.js-valid-letters').each(function () {
            setInputFilter(this, function (value) {
                return /^[a-zA-ZáéíóúÁÉÍÓÚ\'´ñÑäëïöüÄËÏÖÜ \-]*$/.test(value);
            });
        });
    }
    if ($('.js-valid-alpha-numeric').length) {
        $('.js-valid-alpha-numeric').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9a-zA-Z]*$/.test(value);
            });
        });
    }
    if ($('.js-valid-phone').length) {
        $('.js-valid-phone').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9\-]*$/.test(value);
            });
        });
        $('.js-valid-phone').mask('000-000-0000');
    }
    if ($('.js-valid-date').length) {
        $('.js-valid-date').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9\/]*$/.test(value);
            });
        });
        $('.js-valid-date').mask('09/09/0000');
    }
    if ($('.js-valid-zipcode').length) {
        $('.js-valid-zipcode').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9]*$/.test(value);
            });
        });
    }
})